// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#openbay .form-group[data-v-220882be]{position:relative}#openbay .btn-edit[data-v-220882be]{float:right;opacity:0;transition:opacity .2s ease-in-out}@media(max-width:768px){#openbay .btn-edit[data-v-220882be]{opacity:1}}#openbay .card-body:hover .btn-edit[data-v-220882be]{opacity:1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
